import { useForm, useFieldArray, Controller } from "react-hook-form";
import { Input, message } from "antd";
import Button from "~/components/Button";
import Loading from "~/components/Loading";
import { Icon } from "~/components";

// Form thêm NHIỀU liên hệ vào nguồn gọi điện cùng lúc — mỗi hàng là 1 liên hệ.
// Chấp nhận cả di động (10 số) và số cố định (11 số).
const phoneRegExp = /^0\d{9,10}$/;

const EMPTY_ROW    = { name: '', phone: '', address: '', website: '', note: '' };
const INITIAL_ROWS = 10;

const makeRows = (n) => Array.from({ length: n }, () => ({ ...EMPTY_ROW }));

const thStyle = {
	padding: '6px 8px',
	textAlign: 'left',
	fontWeight: 600,
	fontSize: 13,
	background: '#fafafa',
	borderBottom: '1px solid #f0f0f0',
	position: 'sticky',
	top: 0,
	zIndex: 1,
};

const tdStyle = {
	padding: '2px 4px',
	borderBottom: '1px solid #f5f5f5',
	verticalAlign: 'middle',
};

// Ô nhập trong lưới — dùng Controller vì antd Input không tương thích register (ref)
function CellInput({ control, name, onFocus, ...rest }) {
	return (
		<Controller control={control} name={name} render={({ field }) => (
			<Input size="small" bordered={false} {...field} onFocus={onFocus} {...rest} />
		)} />
	);
}

function SaleCallSourceContactForm({ onHandleSubmit, onCancel }) {

	const { control, handleSubmit, formState: { isSubmitting } } = useForm({
		defaultValues: { contacts: makeRows(INITIAL_ROWS) },
	});

	const { fields, append } = useFieldArray({ control, name: 'contacts' });

	// Bấm (focus) vào ô bất kỳ ở hàng cuối → tự thêm 1 hàng trống mới
	const handleFocusRow = (index) => {
		if (index === fields.length - 1) {
			append({ ...EMPTY_ROW });
		}
	};

	const onSubmit = async (data) => {
		const rows      = data.contacts || [];
		const contacts  = [];
		const rowErrors = [];

		rows.forEach((r, idx) => {
			const name    = (r.name    || '').trim();
			const phone   = (r.phone   || '').replace(/\s+/g, '');
			const address = (r.address || '').trim();
			const website = (r.website || '').trim();
			const note    = (r.note    || '').trim();

			// Hàng hoàn toàn trống → bỏ qua
			if (!name && !phone && !address && !website && !note) return;

			const errs = [];
			if (!name)  errs.push('thiếu tên');
			if (!phone) errs.push('thiếu SĐT');
			else if (!phoneRegExp.test(phone)) errs.push(`SĐT "${phone}" không hợp lệ`);

			if (errs.length) {
				rowErrors.push(`Hàng ${idx + 1}: ${errs.join(', ')}`);
			} else {
				contacts.push({ name, phone, address, website, note });
			}
		});

		if (rowErrors.length) {
			const shown = rowErrors.slice(0, 5).join(' | ');
			const more  = rowErrors.length > 5 ? ` … (+${rowErrors.length - 5} hàng lỗi khác)` : '';
			message.error(shown + more);
			return;
		}

		if (contacts.length === 0) {
			message.warning('Bạn chưa nhập liên hệ nào');
			return;
		}

		await onHandleSubmit({ contacts });
	};

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{isSubmitting && <Loading />}
			<p className="heading">Nhập nhiều liên hệ — mỗi hàng là một liên hệ</p>
			<p style={{ color: '#888', fontSize: 13, marginBottom: 10 }}>
				Bắt buộc nhập <b>Tên</b> và <b>Số điện thoại</b>. Bấm vào ô ở hàng cuối sẽ tự thêm hàng mới.
				Hàng trống sẽ được bỏ qua, số trùng lịch hẹn / nguồn hiện có sẽ tự bỏ qua.
			</p>

			<div style={{ maxHeight: 440, overflowY: 'auto', overflowX: 'auto', border: '1px solid #f0f0f0', borderRadius: 6 }}>
				<table style={{ width: '100%', borderCollapse: 'collapse' }}>
					<thead>
						<tr>
							<th style={{ ...thStyle, width: 42, textAlign: 'center' }}>#</th>
							<th style={thStyle}>Tên (KH / công ty) <span style={{ color: '#f5222d' }}>*</span></th>
							<th style={{ ...thStyle, width: 150 }}>Số điện thoại <span style={{ color: '#f5222d' }}>*</span></th>
							<th style={thStyle}>Địa chỉ</th>
							<th style={thStyle}>Website</th>
							<th style={thStyle}>Ghi chú</th>
						</tr>
					</thead>
					<tbody>
						{fields.map((field, index) => (
							<tr key={field.id}>
								<td style={{ ...tdStyle, textAlign: 'center', color: '#999', fontSize: 13 }}>{index + 1}</td>
								<td style={tdStyle}>
									<CellInput control={control} name={`contacts.${index}.name`} placeholder="Tên..." onFocus={() => handleFocusRow(index)} />
								</td>
								<td style={tdStyle}>
									<CellInput control={control} name={`contacts.${index}.phone`} placeholder="0xxxxxxxxx" onFocus={() => handleFocusRow(index)} />
								</td>
								<td style={tdStyle}>
									<CellInput control={control} name={`contacts.${index}.address`} placeholder="Địa chỉ..." onFocus={() => handleFocusRow(index)} />
								</td>
								<td style={tdStyle}>
									<CellInput control={control} name={`contacts.${index}.website`} placeholder="https://..." onFocus={() => handleFocusRow(index)} />
								</td>
								<td style={tdStyle}>
									<CellInput control={control} name={`contacts.${index}.note`} placeholder="Ghi chú..." onFocus={() => handleFocusRow(index)} />
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>

			<hr />
			<div className="form-group d-flex justify-content-between modal-bottom">
				<Button white type="button" leftIcon={Icon.plus} onClick={() => append({ ...EMPTY_ROW })}>
					Thêm hàng
				</Button>
				<div className="d-flex gap">
					{onCancel && <Button white type="button" onClick={onCancel}>Đóng</Button>}
					<Button primary type="submit" leftIcon={Icon.plus}>Thêm liên hệ</Button>
				</div>
			</div>
		</form>
	);
}

export default SaleCallSourceContactForm;
